<template>
  <b-row class="margin-0 padding-x-16">
    <b-col
      v-for="(item, index) in items"
      :key="index"
      cols="12"
      class="border--solid border--complementary-50 border-radius-8 padding-x-12 padding-y-8 margin-bottom-8"
    >
      <div class="flex-between">
        <div class="width-percent-100">
          <b-skeleton width="70%" class="margin-bottom-8"></b-skeleton>
          <b-skeleton width="90%" class="margin-bottom-8"></b-skeleton>
          <b-skeleton width="90%"></b-skeleton>
        </div>
        <b-skeleton type="button" class="width-24 height-24"></b-skeleton>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import { computed, toRefs } from "vue";
export default {
  props: {
    count: {
      type: Number,
      default: 6,
    },
  },
  setup(props) {
    // generate props data
    const { count } = toRefs(props);

    const items = computed(() => {
      const arr = [];
      arr.length = count.value;
      return arr;
    });

    // return data to be used in template
    return { items };
  },
};
</script>
